import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      50: '#fee3e7',
      100: '#fdb9c2',
      200: '#fb8b9a',
      300: '#f95d72',
      400: '#f83a53',
      500: '#f71735',
      600: '#f61430',
      700: '#f51128',
      800: '#f30d22',
      900: '#f10716',
      A100: '#ffffff',
      A200: '#ffe6e7',
      A400: '#ffb3b6',
      A700: '#ff9a9e',
      main: '#F71735',
      contrastText: '#fff',
    },
    secondary: {
      50: '#e2fff2',
      100: '#b7ffdf',
      200: '#87ffca',
      300: '#57ffb5',
      400: '#33ffa5',
      500: '#0fff95',
      600: '#0dff8d',
      700: '#0bff82',
      800: '#08ff78',
      900: '#04ff67',
      A100: '#ffffff',
      A200: '#f2fff7',
      A400: '#bfffd5',
      A700: '#a6ffc4',
      main: '#0FFF95',
      contrastText: '#fff',
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161"
    }
  },
});